/** @jsx jsx */
import React, { useMemo } from 'react';
import { jsx } from '@emotion/core';
import ExpandablePanel from 'components/ExpandablePanel';
import styles from './styles';
import useTranslate from 'hooks/useTranslate/useTranslate';
import { Order } from 'state/creditApplication';
import { conformToMask, decimalMoneyMask } from 'utils/masks';

export interface PropTypes {
  order: Order;
}

const ShippingMethod: React.FC<PropTypes> = props => {
  const { order } = props;
  const t = useTranslate();

  const shippingDescription = useMemo(() => {
    if (!order.totalShippingValue && !order.shippingDescription) {
      return null;
    }
    const ifShippingDescriptionPresent = order.shippingDescription
      ? order.shippingDescription
      : '';
    const dashIfBothArePresent =
      order.totalShippingValue && order.shippingDescription ? ' - ' : '';

    const ifShippingCostValuePresent = order.totalShippingValue
      ? conformToMask(order.totalShippingValue.toFixed(2), decimalMoneyMask)
      : '';

    return (
      <p
        css={styles.panelSecondaryText}
      >{`${ifShippingDescriptionPresent} ${dashIfBothArePresent}${ifShippingCostValuePresent}`}</p>
    );
  }, [order.shippingDescription, order.totalShippingValue]);

  return (
    <ExpandablePanel
      title={
        <span css={styles.panelText}>
          <img
            css={styles.panelIcon}
            src={`data:image/png;base64,${t(
              'unified.placeOrder.label.shippingIcon',
            )}`}
            alt="Shipping"
          />
          <p css={styles.panelTitle}>
            {t('unified.placeOrder.label.shippingMethod')}
          </p>
          {/** How will we get this? First item? **/}
          {shippingDescription}
        </span>
      }
      panelName={'shippingMethod'}
    >
      {order.totalShippingValue || order.shippingDescription ? (
        <div css={styles.panelText}>
          {order.shippingDescription ? (
            <p css={styles.panelContentTitle}>{order.shippingDescription}</p>
          ) : null}
          {order.totalShippingValue ? (
            <p css={styles.panelSecondaryText}>
              {conformToMask(
                order.totalShippingValue.toFixed(2),
                decimalMoneyMask,
              )}
            </p>
          ) : null}
        </div>
      ) : null}
      <p css={styles.panelFinePrint}>{order.shippingProvider}</p>
    </ExpandablePanel>
  );
};

export default ShippingMethod;
